import { AuditResourceType } from '_lib/api';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { AuditListState, EMPTY_AUDIT_LIST, historyKey } from './auditTypes';

const auditStateDomain = (state: RootState) => state.audit;

export const auditListSelector = createSelector(auditStateDomain, (audit) => audit.list);

export const auditFiltersSelector = createSelector(auditStateDomain, (audit) => audit.filters);

export const auditTotalSelector = createSelector(auditStateDomain, (audit) => audit.list.total);

export const auditCurrentPageSelector = createSelector(
  auditStateDomain,
  (audit) => audit.paginationCurrentPage,
);

export const auditItemsPerPageSelector = createSelector(
  auditStateDomain,
  (audit) => audit.paginationItemsPerPage,
);

export const auditHistorySelector = (resourceType: AuditResourceType, resourceId: string) =>
  createSelector(
    auditStateDomain,
    (audit): AuditListState =>
      audit.history[historyKey(resourceType, resourceId)] ?? EMPTY_AUDIT_LIST,
  );
